<!--  -->
<template>
  <a @click="handleLink()"
     :class="{'no_decoration':!linkData.name}">{{linkData.title}}</a>
</template>

<script>
export default {
  name: 'zlr-remind-link',
  props: ['data'],
  components: {},
  data () {
    return {
      linkData: {}
    }
  },
  computed: {},
  mounted () {
    this.messageMap()
  },
  methods: {
    handleLink () {
      let { name, params } = this.linkData
      if (!name) return false
      this.$emit('on-click')
      this.$router.push({
        name,
        params
      })
    },
    messageMap () {
      let itemData = this.data
      let type = itemData.type
      let data = {}
      switch (type) {
        case 'DETAIL_INFO':
          data.title = 'Detail info'
          break
        case 'CHANGEPWD':
          data = {
            title: 'Change password'
          }
          break
        case 'INTERVIEW_APPOINTMENT':
        case 'ESSAY':
          data = {
            title: 'Program',
            params: {
              id: itemData.menteeNum
            },
            name: 'mentee-program'
          }
          break
        case 'CV':
        case 'RL':
          data = {
            title: 'CV / RL',
            params: {
              id: itemData.menteeNum
            },
            name: 'mentee-cv-rl'
          }
          break
        case 'APPOINTMENT':
          data = {
            title: 'Appointment',
            params: {
              id: itemData.menteeNum
            },
            name: 'mentee-appointment'
          }
          break
        case 'CONTACT_US':
          data = {
            title: 'Contact us',
            name: 'contact'
          }
          break
        case 'TEAM':
          data = {
            title: itemData.menteeName,
            name: 'home'
          }
          break
      }
      this.linkData = data
    }
  },
  watch: {
    data () {
      this.messageMap()
    }
  }
}
</script>
<style lang='less' scoped>
.no_decoration {
  text-decoration: none !important;
  cursor: inherit;
}
</style>
